import StackedClusteredBar from './StackedClusteredBar';

export default StackedClusteredBar;
